
<transition name="partner-list">
  <section v-if="displayKeys.length > 0 && isPartnersLive" class="mb-64">
    <h3 v-if="showHeader" class="text-h4 mb-16">Highlighted care through our partners</h3>
    <transition-group tag="div" name="partner-tiles" class="flex overflow-x-scroll lg:overflow-x-visible hide-scrollbar pb-24">
      <div v-for="key in displayKeys" :key="key" class="partner-tiles-item">
        <PoppinsBHPartnerTile
          :logoImage="ALL_PARENT_PARTNER_TILES[key].logoImage"
          :companyName="ALL_PARENT_PARTNER_TILES[key].companyName"
          :headerText="ALL_PARENT_PARTNER_TILES[key].headerText"
          :bodyText="ALL_PARENT_PARTNER_TILES[key].bodyText"
          :ctaText="ALL_PARENT_PARTNER_TILES[key].ctaText"
          :ctaLink="ALL_PARENT_PARTNER_TILES[key].ctaLink"
          class="w-[369px] h-[275px] mr-16"
          @close="closeTile(key)"
          @ctaClicked="ctaClicked(key)"
        />
      </div>
    </transition-group>
    <a class="button button-text mt-16" href="/explore/partners">More partners</a>
  </section>
</transition>
